export default "__VITE_ASSET__BvOEK6r___"